import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { UNIT_TYPES } from 'constants'
import { fortBattleStartedLessThanHourAgo } from 'helpers/schedule'
import { getAvailablePeripheries } from 'helpers/peripheries'
import { isPlayersMatchingAvailable } from 'helpers/playersMatching'
import { requestScheduleData } from 'state/actions/schedule'

import UnitPreview from './components/UnitPreview/UnitPreview'
import UnitsView from './containers/UnitsView/UnitsView'
import PlayersMatchingView from './containers/PlayersMatchingView/PlayersMatchingView'
import FullSchedule from './components/FullSchedule/FullSchedule'

import { UnitDataPropTypes } from './propTypes'

export class BattleRooms extends React.Component {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        meta: PropTypes.object,
        selectedClanUnit: UnitDataPropTypes,

        playersMatchingTabOpen: PropTypes.bool.isRequired,

        todaySchedule: PropTypes.object,

        requestScheduleData: PropTypes.func.isRequired,
    }

    componentWillMount() {
        const schedule_period = 7  // schedule repeats every week
        this.props.requestScheduleData(schedule_period)
    }

    shouldShowSchedule(unitType) {
        if (!this.props.meta) return false

        if (unitType === UNIT_TYPES.SORTIE || unitType === undefined) {
            const peripheries = this.props.meta.sorties.peripheries
            if (getAvailablePeripheries(peripheries, UNIT_TYPES.SORTIE).length) return false
        }

        if (unitType === UNIT_TYPES.FORT_BATTLE || unitType === undefined) {
            if (fortBattleStartedLessThanHourAgo(this.props.todaySchedule)) return false

            const peripheries = this.props.meta.fort_battles.peripheries
            if (getAvailablePeripheries(peripheries, UNIT_TYPES.FORT_BATTLE).length) return false
        }

        return true
    }

    render() {
        if (this.shouldShowSchedule()) return <FullSchedule />

        if (this.props.selectedClanUnit) {
            return <UnitPreview unit={this.props.selectedClanUnit} />
        }

        const showBattleModeSchedule = this.shouldShowSchedule(this.props.filter.unitType)
        if (this.props.playersMatchingTabOpen) {
            return (
                <PlayersMatchingView showSchedule={showBattleModeSchedule} />
            )
        } else {
            return (
                <UnitsView showSchedule={showBattleModeSchedule} />
            )
        }
    }
}

export const mapStateToProps = ({ availableUnits, clanUnits, schedule, players_matching, account }) => {
    const meta = (players_matching.active && clanUnits.loaded && clanUnits.meta) ||
        (availableUnits.loaded && availableUnits.meta)

    const selectedClanUnit = clanUnits.units.find(unit => unit.id === clanUnits.selectedUnitId)
    const playersMatchingAvailable = isPlayersMatchingAvailable(account, players_matching)

    return {
        todaySchedule: schedule.playdays ? schedule.playdays[0] : null,
        filter: availableUnits.filter,
        meta,
        selectedClanUnit,
        playersMatchingTabOpen: playersMatchingAvailable && players_matching.active,
    }
}

export const mapDispatchToProps = {
    requestScheduleData,
}

export default connect(mapStateToProps, mapDispatchToProps)(BattleRooms)



// WEBPACK FOOTER //
// ./containers/BattleRooms/BattleRooms.jsx